module.exports = __webpack_public_path__ + "img/icon-edit.e9d6550d.svg";